<template>
  <header class="mc-appbar">
    <button
      v-if="showBack"
      class="mc-back"
      type="button"
      aria-label="Back"
      @click="$emit('back')"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>

    <div class="mc-brandtext">
      <b class="mc-brand-title">APA Insurance</b>
      <span class="mc-brand-subtitle">{{ subtitle }}</span>
    </div>

    <span v-if="stepLabel" class="mc-steppill">{{ stepLabel }}</span>

    <img src="@/assets/header.png" alt="APA Insurance" class="mc-logo" />
  </header>
</template>

<script>
export default {
  name: 'AppBar',
  props: {
    showBack: { type: Boolean, default: false },
    subtitle: { type: String, default: 'Motor claim · First Notice of Loss' },
    stepLabel: { type: String, default: '' },
  },
}
</script>

<style scoped>
/* Mobile is the blue bar the design specifies: no logo, step pill on the right.
   Desktop (641px+) goes white with the logo in the pill's place — there the
   progress rail and case-file sidebar already say which step you are on. */
.mc-appbar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #034ea2;
  color: #fff;
  padding: 12px 16px;
  position: relative;
  z-index: 5;
}

.mc-back {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border: 0;
  border-radius: 999px;
  /* solid tints rather than translucent white: opacity-over-blue resolves fine
     in the browser but reads as near-white-on-white to a flat contrast check */
  background: #2667af;
  color: #fff;
  display: grid;
  place-items: center;
  cursor: pointer;
}

.mc-back:active {
  background: #457cba;
}

.mc-brandtext {
  min-width: 0;
}

.mc-brandtext b {
  display: block;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

.mc-brandtext span {
  display: block;
  font-size: 11.5px;
  color: #d8ebf9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mc-steppill {
  margin-left: auto;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
  background: #306eb3;
  color: #fff;
}

.mc-logo {
  display: none;
}

@media (min-width: 641px) {
  .mc-appbar {
    background: #fff;
    color: #14142b;
    border-bottom: 1px solid #e8e8e8;
  }

  .mc-back {
    background: #eff0f6;
    color: #14142b;
  }

  .mc-back:active {
    background: #d9dbe9;
  }

  .mc-brandtext span {
    color: #6e7191;
  }

  .mc-steppill {
    display: none;
  }

  .mc-logo {
    display: block;
    margin-left: auto;
    flex: 0 0 auto;
    width: 84px;
  }
}
</style>
